/**
 * 앱 경로. `pathname.startsWith(...)` 로 권한을 가르지 않는다 — 라우트 메타를 쓴다.
 * 화면 경로는 기존 서비스(`~/dev/d3/d3-repo` `routes/*.route.tsx`)와 같다. 화면 목록은 `SCREEN`.
 */
export const APP_PATH = {
  root: '/',
  login: '/login',
  findPassword: '/findpassword',
  resetPassword: '/resetpassword',
  fundDetail: '/fund/:id',
  fundWrite: '/fund-write',
  fundEdit: '/fund/:id/edit',
  portfolioDetail: '/portfolio/:id',
  portfolioWrite: '/portfolio-write',
  portfolioEdit: '/portfolio/:id/edit',
  portfolioAddData: '/portfolio/:id/add-data',
  portfolioCaptable: '/portfolio/:id/captable',
  portfolioReport: '/portfolio-report',
  portfolioEvaluation: '/portfolio-evaluation',
  file: '/file',
  member: '/member',
  mail: '/mail',
  info: '/info',
  config: '/config',
  accessLog: '/access-log',
} as const;

/** 재설정 화면(S03) 주소의 토큰 이름. 서버가 보내는 메일 링크 = `/resetpassword?token=`(기존 서비스와 같다) */
export const RESET_TOKEN_PARAM = 'token';

/** 포트폴리오 상세(S08) 주소의 펀드 필터 이름 — `?fund=` 면 그 펀드의 투자 · 사용액만 계산한 값을 본다 */
export const PORTFOLIO_FUND_PARAM = 'fund';

type Id = number | string;
type PortfolioFilter = { fund?: Id };

const withFund = (path: string, filter?: PortfolioFilter) =>
  filter?.fund === undefined ? path : `${path}?${PORTFOLIO_FUND_PARAM}=${filter.fund}`;

/**
 * 화면 사이 링크를 만드는 곳. 페이지 · 위젯은 경로 문자열을 손으로 쓰지 않고 이것을 쓴다
 * (다른 page slice 를 import 하지 않고 링크를 걸 수 있다).
 */
export const appPath = {
  fundDetail: (id: Id) => `/fund/${id}`,
  fundEdit: (id: Id) => `/fund/${id}/edit`,
  /**
   * `fund` 를 주면 그 펀드로 거른 상세(`?fund=`). 기존 서비스는 펀드 상세를 거쳐 들어오거나(직전 화면이 펀드)
   * 포트폴리오 목록의 펀드명을 누르면 그 펀드로 거른 상세를 보였다(DD-46 #2).
   */
  portfolioDetail: (id: Id, filter?: PortfolioFilter) => withFund(`/portfolio/${id}`, filter),
  /** 상세의 하위 화면(S10 · S11 · S12)도 `?fund=` 를 이어 간다 — BackBar 가 그 펀드로 거른 상세로 돌아간다(화면 트리) */
  portfolioEdit: (id: Id, filter?: PortfolioFilter) => withFund(`/portfolio/${id}/edit`, filter),
  portfolioAddData: (id: Id, filter?: PortfolioFilter) =>
    withFund(`/portfolio/${id}/add-data`, filter),
  portfolioCaptable: (id: Id, filter?: PortfolioFilter) =>
    withFund(`/portfolio/${id}/captable`, filter),
} as const;
